import { Card, CardContent } from '@/components/ui/Card';
import { Badge } from '@/components/ui/Badge';
import type { Maintenance } from '@/types/admin.types';
import { formatDateTime } from '@/utils/formatters';
import { Clock, Wrench } from 'lucide-react';

interface MaintenanceCalendarProps {
  maintenances: Maintenance[];
}

export function MaintenanceCalendar({ maintenances }: MaintenanceCalendarProps) {
  if (maintenances.length === 0) {
    return (
      <div className="flex flex-col items-center py-8 text-center">
        <Wrench className="h-10 w-10 text-neutral-400 dark:text-neutral-600 mb-2" />
        <p className="text-sm text-neutral-600 dark:text-neutral-400">Aucune maintenance planifiée</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {maintenances.map((m) => (
        <Card key={m.uuid}>
          <CardContent>
            <div className="flex items-start justify-between">
              <div>
                <h4 className="font-medium text-neutral-900 dark:text-neutral-200">{m.title}</h4>
                <p className="mt-1 text-xs text-neutral-500">{m.description}</p>
                <div className="mt-2 flex items-center gap-2 text-xs text-neutral-600 dark:text-neutral-400">
                  <Clock className="h-3 w-3" />
                  {formatDateTime(m.scheduledStartAt)} - {formatDateTime(m.scheduledEndAt)}
                </div>
              </div>
              <Badge variant={m.status === 'scheduled' ? 'info' : m.status === 'in_progress' ? 'warning' : 'success'}>
                {m.status}
              </Badge>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
